export default {
  getState: state => state.state,
  getPos: state => state.pos,
  getSeller: state => state.seller,
  getCaption: state => state.caption,
  getWallet: state => state.wallet,
  getStateOptions: state => state.stateOptions,
  getPosOptions: state => state.posOptions,
  getSellerOptions: state => state.sellerOptions,
  getCaptationOptions: state => state.captationOptions,
}
